import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceStore } from '@app/store/device';
import { environment } from '@env/environment';
import { AmplitudeExperimentAction } from '@actions/amplitde-experiment/amplitde-experiment.action';

export type MiddlewareExitIntentVariant = 'control' | 'variantB';
export type MiddlewareLayoutVariant = 'control' | 'variantB';

const { SYSTEM_USAGE } = environment;

@Injectable({
  providedIn: 'root',
})
export class MiddlewareService {
  private readonly EXPERIMENT_KEY = 'modal-abandonment-middleware';
  private readonly LAYOUT_EXPERIMENT_KEY = 'offer-middleware';

  constructor(
    private http: HttpClient,
    private deviceStore: DeviceStore,
    private amplitudeExperiment: AmplitudeExperimentAction,
  ) {}

  systemUsage(eventName: string, dealId?: string | {}, data?: any) {
    const payload = {
      event_name: eventName,
      device: this.deviceStore.getDeviceType(),
      deal_id: dealId,
      ...data,
    };
    const url = `${SYSTEM_USAGE}/action`;
    return this.http.post(url, { ...payload });
  }

  async getExitIntentVariant(): Promise<MiddlewareExitIntentVariant> {
    try {
      const variant = await this.getVariantFromAmplitude(this.EXPERIMENT_KEY);
      return this.mapVariantKey(variant) as MiddlewareExitIntentVariant;
    } catch (error) {
      console.error('Error fetching variant from Amplitude, defaulting to control:', error);
      return 'control';
    }
  }

  async getLayoutVariant(): Promise<MiddlewareLayoutVariant> {
    try {
      const variant = await this.getVariantFromAmplitude(this.LAYOUT_EXPERIMENT_KEY);
      return this.mapVariantKey(variant) as MiddlewareLayoutVariant;
    } catch (error) {
      console.error('Error fetching layout variant from Amplitude, defaulting to control:', error);
      return 'control';
    }
  }

  private async getVariantFromAmplitude(experimentKey: string): Promise<string> {
    try {
      await this.amplitudeExperiment.initializeAmplitudeExperiment();

      const variant = this.amplitudeExperiment.experiment.variant(experimentKey);

      if (!variant || !variant.key) {
        console.log('⚠️ [MiddlewareService] Variant não encontrado ou sem key, retornando control');
        return 'control';
      }
      return variant.key;
    } catch (error) {
      console.error('Error getting variant from Amplitude:', error);
      throw error;
    }
  }

  private mapVariantKey(variantKey: string): 'control' | 'variantB' {
    switch (variantKey) {
      case 'control':
        return 'control';
      case 'variantB':
      case 'treatment-2':
        return 'variantB';
      default:
        return 'control';
    }
  }
}
